import React from "react"

const Links = ({ component: Component = "a", children, ...props }) => {
    return (
        <Component {...props} style={{ textDecoration: "none" }}>
            {children}
        </Component>
    )
}

export default Links
